import { Card, CardHeader, CardFooter } from '@/components/bootstrap/TemporaryReactstrapCompatibilityLayer';
import { plantTaskConfig } from "../../constants/plantTaskMappings.js";
import getCardData from "./plantTaskCardUtils.jsx";

const PlantTaskCard = ({ plantTask, onTaskClick }) => {
    const taskMapper = plantTaskConfig[plantTask.processType];

    const { headers, values } = getCardData(taskMapper?.label, plantTask);

    return (
      <Card className="plant-task-card" onClick={() => onTaskClick(plantTask)}>
        <CardHeader className="plant-task-card-header">
            <div className="plant-task-process-type">{taskMapper?.label}</div>
            <div className="plant-task-process-type-icon">
            <i className={`${taskMapper?.icon}`}></i>
            </div>
        </CardHeader>
        <CardFooter className="plant-task-card-body">
            <div className="plant-task-card-table">
                <div className={`plant-task-card-row ${taskMapper?.label?.toLowerCase()}`}>
                    {headers?.map((header, idx) => (
                    <div className="plant-task-card-cell header" key={`header-${idx}`}>
                        {header}
                    </div>
                    ))}
                </div>
                <div className={`plant-task-card-row ${taskMapper?.label?.toLowerCase()}`}>
                    {values?.map((value, idx) => (
                    <div className="plant-task-card-cell value" key={`value-${idx}`}>
                        {value}
                    </div>
                    ))}
                </div>
            </div>
        </CardFooter>
        </Card>
    );
};

export default PlantTaskCard;
